// /opt/isp_erp/frontend/src/pages/warehouse/DespacharEquipo.jsx
import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  Alert,
  Snackbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Paper
} from '@mui/material';
import { Send, Cancel } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { warehouseAPI } from '../../api/warehouse.api';
import axios from '../../api/axios'; // Usar el mismo axios que en instalaciones

const DespacharEquipo = () => {
  const navigate = useNavigate();
  const { sn } = useParams();
  const [loading, setLoading] = useState(false);
  const [tecnicos, setTecnicos] = useState([]);
  const [cargandoTecnicos, setCargandoTecnicos] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    sn: sn || '',
    tecnico_id: '',
    observaciones: ''
  });

  useEffect(() => {
    cargarTecnicos();
    if (sn) {
      setFormData(prev => ({ ...prev, sn }));
    }
  }, [sn]);

  const cargarTecnicos = async () => {
    try {
      // Misma lógica que en Installations.jsx
      const techRes = await axios.get("/users");
      // Filtrar usuarios con rol tecnico_campo (exactamente como en instalaciones)
      const tecnicosFiltrados = techRes.data.filter(user =>
        user.roles?.some(role => role.name === "tecnico_campo")
      );
      setTecnicos(tecnicosFiltrados);
    } catch (error) {
      console.error("Error cargando técnicos:", error);
      setError("Error al cargar lista de técnicos");
    } finally {
      setCargandoTecnicos(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.tecnico_id) {
      setError('Debe seleccionar un técnico');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await warehouseAPI.despacharEquipo({
        sn: formData.sn,
        tecnico_id: parseInt(formData.tecnico_id),
        observaciones: formData.observaciones
      });
      
      setSuccess(true);
      setTimeout(() => {
        navigate('/warehouse/equipos');
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al despachar el equipo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Despachar Equipo a Técnico
      </Typography>
      
      <Card>
        <CardContent>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Número de Serie (SN)"
                  name="sn"
                  value={formData.sn}
                  disabled
                  helperText="Equipo que será despachado"
                />
              </Grid>
              
              <Grid item xs={12}>
                <FormControl fullWidth required>
                  <InputLabel>Técnico Asignado</InputLabel>
                  <Select
                    name="tecnico_id"
                    value={formData.tecnico_id}
                    onChange={handleChange}
                    label="Técnico Asignado"
                    disabled={cargandoTecnicos}
                  >
                    <MenuItem value="">
                      <em>Seleccione un técnico</em>
                    </MenuItem>
                    {tecnicos.map((tecnico) => (
                      <MenuItem key={tecnico.id} value={tecnico.id}>
                        {tecnico.username} - {tecnico.email}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {cargandoTecnicos && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <CircularProgress size={24} />
                  </Box>
                )}
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Observaciones"
                  name="observaciones"
                  multiline
                  rows={3}
                  value={formData.observaciones}
                  onChange={handleChange}
                  placeholder="Instrucciones adicionales para el técnico..."
                />
              </Grid>
              
              <Grid item xs={12}>
                <Paper sx={{ p: 2, bgcolor: '#fff3e0' }}>
                  <Typography variant="body2" color="warning.main">
                    <strong>⚠️ Importante:</strong> Al despachar, el equipo cambiará a estado 
                    <strong> EN_TRÁNSITO</strong> y quedará bajo responsabilidad del técnico seleccionado.
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                  <Button
                    variant="outlined"
                    onClick={() => navigate('/warehouse/equipos')}
                    startIcon={<Cancel />}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={loading || !formData.tecnico_id}
                    startIcon={loading ? <CircularProgress size={20} /> : <Send />}
                  >
                    {loading ? 'Despachando...' : 'Despachar Equipo'}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
      
      <Snackbar
        open={success}
        autoHideDuration={3000}
        onClose={() => setSuccess(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="success" sx={{ width: '100%' }}>
          Equipo despachado exitosamente
        </Alert>
      </Snackbar>
      
      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError('')}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default DespacharEquipo;
